import { useCommonData } from '@udemy-v2/common-data';
import { useOrgBranding } from '@/lib/hooks/use-org-branding';
export const useUserHasOrganization = () => {
  const commonData = useCommonData();
  const orgBranding = useOrgBranding();
  return !!commonData?.organization || !!orgBranding;
};